import Styles from './MobileSelectImage.module.scss'
import { useImagePickerContext } from 'components/ImagePickerModal/ImagePickerContext'
import { Button } from 'blaze-ui/Button'
import { Images } from 'blaze-ui/icons'
import { Checkbox } from 'components/Form/Checkbox/Checkbox'
import { useEffect, useState } from 'react'
import { useDebounce } from 'hooks/useDebounce'
import { useUnsplashImages } from 'hooks/queries/useUnsplashImages'
import { collectResults } from 'utils/query'
import { ShimmeringColor } from 'components/BrandWizardVisualAnalysisModal/LoadingState'
import cx from 'classnames'

interface Props {
  onMoreClick?: () => void
}

export const StockImages = ({ onMoreClick }: Props) => {
  const imagePickerContext = useImagePickerContext()
  const [resetImage, setResetImage] = useState(false)
  const { selectedImages, initialQuery, toggleSelectedImage } = imagePickerContext
  const [query] = useState(initialQuery || '')
  const debouncedQuery = useDebounce(query, 500)
  const unsplashQuery = useUnsplashImages({ query: debouncedQuery, perPage: 4 })
  const results = collectResults(unsplashQuery, (data) => data.results || data)

  const stockImages = results.map((item) => {
    return {
      url: item.urls.regular,
      unsplash: {
        authorUsername: item.user.username,
        authorName: item.user.name,
        id: item.id,
        query,
      },
    }
  })

  useEffect(() => {
    if (stockImages.length > 0 && !resetImage) {
      setResetImage(true)
      toggleSelectedImage(stockImages[0])
    }
  }, [unsplashQuery.isFetched]) // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <>
      {unsplashQuery.isLoading ? (
        <div className={Styles.imagesSection}>
          <div className={Styles.selectedImage}>
            <ShimmeringColor aspectRatio={1} />
          </div>
          <div className={Styles.imagesGrid}>
            {Array.from(Array(4)).map((_, i) => (
              <div key={`loading-${i}`} className={Styles.image}>
                <ShimmeringColor aspectRatio={1} />
              </div>
            ))}
          </div>
        </div>
      ) : (
        <div className={Styles.imagesSection}>
          <img
            className={Styles.selectedImage}
            src={selectedImages[0]?.source_url || selectedImages[0]?.url || stockImages[0]?.url}
            alt="stock"
          />
          <div className={Styles.imagesGrid}>
            {stockImages.slice(0, 4).map((stockImage) => (
              <div
                key={stockImage.unsplash.id}
                className={cx(Styles.image, {
                  [Styles.isSelected]: stockImage.unsplash.id === selectedImages[0]?.unsplash?.id,
                })}
                onClick={() => toggleSelectedImage(stockImage)}
              >
                <img src={stockImage.url} alt="img" />
                {stockImage.unsplash.id === selectedImages[0]?.unsplash?.id && (
                  <>
                    <div className={Styles.checkbox}>
                      <Checkbox size="lg" isSelected />
                    </div>
                  </>
                )}
              </div>
            ))}
          </div>
          <Button frontIcon={Images} fullWidth variant="secondary" size="lg" onPress={onMoreClick}>
            Browse all stock photos
          </Button>
        </div>
      )}
    </>
  )
}
